




































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * Components
 */
import GenericEditorComponent from './GenericEditorComponent.vue';

/**
 * Types
 */
import { SettingsCategories } from '@/api/settings';

const replacer = function (key: any, value: any) {
	if (value == null) {
		return String('');
	}
	if (typeof value === "number") {

		return String(value);
	}
	return value;
};

/**
 * Composant de formulaire d'édition de settings générique.
 */
@Component({ components: { GenericEditorComponent }, mixins: [mixinsAPI] })
export default class SettingsEditor extends Vue {
	/** Injections */
	fileType = File;

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Propriétés */
	@Prop()
	initialFetchAsync!: () => Promise<any>;
	@Prop()
	saveAsync!: (formData: FormData) => Promise<any>;

	/** Attributs */
	isLoading = false;
	initialForm!: any;
	isTyping = false;
	form: any = null;
	timeZoneInfos: any[] | null = null;

	get meta(): any {
		return {
			general: {
				logo: {
					type: 'image'
				},
				helpFile: {
					type: 'pdf'
				},
				timeZoneInfoID: {
					list: {
						items: this.timeZoneInfos,
						value: 'id',
						text: 'displayName'
					}
				}

			},
			mail: {
				password: {
					type: 'password',
					autocomplete: 'new-password'
				}
			}
		};
	}

	get canSave() {
		return (this.isTyping || !this.isTyping) && this.getSerializedForm() !== this.getSerializedInitialForm();
	}

	/** Méthodes */
	async created() {
		this.isLoading = true;
		await this.fetchSettings();
		this.isLoading = false;
	}
	async fetchSettings() {
		const { settings, timeZoneInfos } = await this.initialFetchAsync();
		this.form = settings;
		this.timeZoneInfos = timeZoneInfos;
		this.initialForm = JSON.parse(this.getSerializedForm());
		this.isTyping = false;
	}

	tryGetMeta(key1: string, key2: string, key3: string) {
		if (key3 == null) {
			return this.meta[key1] ?
				(this.meta[key1][key2] ?
					this.meta[key1][key2]
					: null)
				: null;
		}
		else {
			return this.meta[key1] ?
				(this.meta[key1][key2] ?
					(this.meta[key1][key2][key3] ?
						this.meta[key1][key2][key3]
						: null)
					: null)
				: null;
		}

	}

	getSerializedForm() {
		return JSON.stringify(this.form, replacer);
	}
	getSerializedInitialForm() {
		return JSON.stringify(this.initialForm, replacer);
	}

	appendJsonToFormData(jsonObject: any, formData: FormData, prefix: string = '') {
		for (const key in jsonObject) {
			if (typeof jsonObject[key] === 'object' && !(jsonObject[key] instanceof File)) {
				this.appendJsonToFormData(jsonObject[key], formData, prefix !== '' ? `${prefix}.${key}` : key);
			}
			else {
				formData.append(prefix !== '' ? `${prefix}.${key}` : key, jsonObject[key]);
			}
		}
	}

	async handleSubmit() {
		this.isLoading = true;
		try {
			const formData = new FormData();
			this.appendJsonToFormData(this.form, formData);
			await this.saveAsync(formData);
			this.openInfo(this.$t('snackbar.success'));
			location.reload();
		}
		catch (err) {
			(this as any).handleAPIError(err);
		}
		this.isLoading = false;

	}

	resetForm() {
		this.form = JSON.parse(this.getSerializedInitialForm());
		this.isTyping = false;
	}

	handleValueChanged() {
		this.isTyping = !this.isTyping;
	}
}
